module.exports = __webpack_public_path__ + "8993ec3c2e814c0a76ef756e0e7240c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/landing/preview_section/assets/tv_mobile.png
// module id = ./src/components/landing/preview_section/assets/tv_mobile.png
// module chunks = index